import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import {
  CreateQuestion,
  CreateQuestionResponse,
  QuestionsList,
} from "@/builders/types/questions";

import { id } from "./id";
import { question_option } from "./question-option";

const get = function (
  params?: FilterParams<{
    id?: number | string;
    question_bank?: number;
  }>
) {
  return api
    .get<QuestionsList>("questions", { params })
    .then(({ data }) => data);
};

const post = function (data: CreateQuestion) {
  return api.post<CreateQuestionResponse>("questions", data);
};

export const questions = {
  get,
  post,
  id,
  question_option,
};
